/**
 Set following line to true when deploying to LIVE Environment
*/
import * as firebase from 'firebase';
import dotenv from 'dotenv'
dotenv.config()
console.log('env:', process.env)

// Firebase project configuration params DEVELOPMENT
const firebaseConfig = {
	apiKey: `${process.env.FIREBASE_API_KEY}`,
	//apiKey: "AIzaSyCBy7B16KzP22lemELzYTDyiHmZExxsDug",
	authDomain: "dogmoticswebapp.firebaseapp.com",
	databaseURL: "https://dogmoticswebapp.firebaseio.com",
	projectId: "dogmoticswebapp",
	storageBucket: "dogmoticswebapp.appspot.com",
	messagingSenderId: "244611063061",
	appId: "1:244611063061:web:ffcf88f4eb2ecff3f49d1c",
};
//console.log('api_key:', firebaseConfig.apiKey, process.env)

// Firebase project configuration params LIVE
/*const firebaseConfig = {
	apiKey: "",
	authDomain: "dogmoticswebapp.firebaseapp.com",
	databaseURL: "https://dogmoticswebapp.firebaseio.com",
	projectId: "dogmoticswebapp",
	storageBucket: "dogmoticswebapp.appspot.com",
	messagingSenderId: "244611063061",
	appId: "1:244611063061:web:ffcf88f4eb2ecff3f49d1c",
};*/
// Replace with your cloud functions location
//const functionLocation = 'europe-west3';

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
/*const timestamp = firebase.firestore.FieldValue.serverTimestamp();
const auth = firebaseApp.auth();	
const functions = firebaseApp.functions();*/

/*// Store defaults
// STORE=DM001 - DogMotics1 by Amici di TOBIA - via Sardegna 35 - Milano
const storeDefaults = {
	code: "DM001",
	phonePrefix: "+39",
	city: "Milano",
	province: "MI",
	country: "IT",
	language: "it",
	currency: "eur"
}*/

export { firebaseApp, firebase, db }